import React from 'react';
import PaymentCardForm from './PaymentCardForm';
import SimpleModal from '../commons/modals/SimpleModal';
import * as PaymentsActions from "../../actions/paymentsActions";

class PaymentCards extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      visibleCardId: '',
      addCardModalVisibility: false,
      availableCards: [],
    }

    this.renderAddPaymentCardForm = this.renderAddPaymentCardForm.bind(this)
    this.openAddCardModal = this.openAddCardModal.bind(this)
    this.closeAddCardModal = this.closeAddCardModal.bind(this)
    this.renderContentForEditOrSelectMode = this.renderContentForEditOrSelectMode.bind(this)
    this.renderContentForViewOnlyMode = this.renderContentForViewOnlyMode.bind(this)
    this.CardBrandToFAClassMap = {
      'visa': 'fa-cc-visa',
      'mastercard': 'fa-cc-mastercard',
      'jcb': 'fa-cc-jcb',
      'discover': 'fa-cc-discover',
      'diners': 'fa-cc-diners-club',
      'amex': 'fa-cc-amex',
      'paypal': 'fa-cc-paypal'
    }
    this.loadPaymentMethods = this.loadPaymentMethods.bind(this);
    this.deletePaymentCard = this.deletePaymentCard.bind(this);
  }

  componentDidMount() {
    this.loadPaymentMethods();
  }

  loadPaymentMethods () {
    const that = this;
    this.props.dispatch(
      PaymentsActions.getAllUserPaymentMethods((response) => {
        if (response.status) {
          that.setState({ availableCards: response.data.data });
        }
      })
    );
  }

  deletePaymentCard (cardId) {
    const {onDeleteCard} = this.props;
    this.props.dispatch(PaymentsActions.deleteCard(cardId, response => {
      if (response.status) {
        this.loadPaymentMethods();
        onDeleteCard && onDeleteCard();
      } else {
        alert('Failed to delete the selected Payment Method');
      }
    }));
  }

  render() {
    const {viewMode} = this.props;
    return (
      <div className="item-list-mobile payment-cards-mobile">
        {viewMode && (viewMode == 'edit' || viewMode == 'select')
          ? this.renderContentForEditOrSelectMode()
          : this.renderContentForViewOnlyMode()}
      </div>
    );
  }

  renderContentForEditOrSelectMode() {
    const {
      viewMode,
      onSelectCard,
      selectedCard,
    } = this.props;
    const cards = this.state.availableCards;
    const {addCardModalVisibility} = this.state;
    return (
      <div>
        {cards && cards.length > 0
          ? (cards.map((card, idx) => {
            let cardIconClassName = this.CardBrandToFAClassMap[card.card.brand] ? this.CardBrandToFAClassMap[card.card.brand] : 'fa-credit-card';

            return (
              <div className="info-row" key={`card_${idx}_row`} onClick={() => onSelectCard
              ? onSelectCard(card)
              : null}>
                <div className="content-left">
                <i className={`fa ${cardIconClassName} card-icon`} />
                  {`XXXXXXXXXXXX ${card.card.last4}`}
                </div>
                {viewMode === 'select'
                  ? (
                    <div className="content-right"><i className={`fa fa${selectedCard && (card.id === selectedCard.id)
                      ? '-circle'
                      : '-circle-o'} icon`} /></div>
                  )
                  : null}
                {viewMode === 'edit'
                  ? (
                    <div className="content-right"><i className="fa fa-trash-o icon" onClick={() => this.deletePaymentCard(card.id)}/>
                    </div>
                  )
                  : null}
              </div>
            )
          }))
          : (
            <div className="info-row">
              <span className="text-italic">No Payment Method Added</span>
            </div>
          )}
        {(viewMode === 'edit' || viewMode === 'select')
          ? (
            <div className="info-row add-card-row" onClick={() => this.openAddCardModal()}>
              <div className="content-left">
                <div className="add-card-icon">
                  <i className="fa fa-plus" />
                </div>
                <span>Add New Payment Card</span>
              </div>
              <div className="content-right"><i className="fa fa-angle-right icon" /></div>
            </div>
          )
          : null}

        {addCardModalVisibility ? (
          <SimpleModal title="Add New Payment Card"
            customClass="add-card-modal"
            onCloseRequest={this.closeAddCardModal}>
            <div className="payment-cards-container">
              {this.renderAddPaymentCardForm()}
            </div>
          </SimpleModal>
        ) : null}

      </div>
    )
  }

  renderContentForViewOnlyMode() {
    const {selectedCard} = this.props;
    let cardIconClassName = selectedCard && this.CardBrandToFAClassMap[selectedCard.brand]
      ? this.CardBrandToFAClassMap[selectedCard.brand]
      : 'fa-credit-card';
    return (
      <div className="info-row">
        <div className="content-left">
          <i className={`fa ${cardIconClassName} card-icon`} />
          {`XXXXXXXXXXXX ${selectedCard.last4}`}
        </div>
      </div>
    );
  }

  renderAddPaymentCardForm() {
    return (
      <PaymentCardForm 
        theme={'dark'} 
        dispatch={this.props.dispatch}
        onAddCardRequest={() => {
          this.loadPaymentMethods();
          this.setState({ 
            addCardModalVisibility: false
          });
        }}
      />
    );
  }

  openAddCardModal() {
    this.setState({ addCardModalVisibility: true })
  }

  closeAddCardModal() {
    this.setState({ addCardModalVisibility: false })
  }

}

export default PaymentCards;



// WEBPACK FOOTER //
// ./src/components/checkout/PaymentCardsMobile.js